import React from 'react';

const Test: React.FC = () => {
  return (
    <div>
      <h1>Test Page</h1>
      <p>This is a test page for visualiation tools.</p>
    </div>
  );
};

export default Test;
